import React from "react";

function IconHomeCheck() {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 19">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.32 1.779a.656.656 0 0 1 .86 0l6.125 5.3a.656.656 0 0 1 .227.496V15.4a.656.656 0 0 1-.656.656H2.625a.656.656 0 0 1-.656-.656V7.575c0-.19.083-.371.227-.496l6.125-5.3ZM3.282 7.875v6.869H14.22V7.875L8.75 3.143 3.281 7.875Z"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.826 7.923a.656.656 0 0 1 .027.927l-3.301 3.5a.656.656 0 0 1-.908.045l-1.512-1.312a.656.656 0 1 1 .861-.991l1.036.9 2.869-3.042a.656.656 0 0 1 .928-.027Z"
      />
    </svg>
  );
}

export default IconHomeCheck;
